// src/Components/Form2/TextArea/TextArea.js
import { useRef, useEffect } from "react";
import css from "../Form.module.css";

const TextArea = ({ children, onChange }) => {
	// children is the field config object
	const { label, name, description, value, placeholder, required, disabled } =
		children || {};
	const id = "id" + Math.random().toString(36).slice(2);
	const ref = useRef(null);

	// keep DOM value in sync when external value changes
	useEffect(() => {
		if (ref.current) ref.current.value = value ?? "";
	}, [value, children]);

	const handleChange = (e) => {
		const newVal = e?.target?.value ?? ref.current?.value ?? "";
		// write back into the config object (like your Input does)
		if (children) children.value = newVal;
		// bubble to form
		onChange?.({ target: { name, value: newVal } });
	};

	return (
		<div className={css.FormControl}>
			<div>
				{label && (
					<label className={css.TextSubLabel} htmlFor={id}>
						{label}
						{required && <span className={css.Required}>*</span>}
					</label>
				)}
				{description && <p className={css.Description}>{description}</p>}
			</div>
			<div>
				<textarea
					id={id}
					name={name}
					placeholder={placeholder}
					required={!!required}
					disabled={!!disabled}
					defaultValue={value}
					onChange={handleChange}
					ref={ref}
				/>
			</div>
		</div>
	);
};

export default TextArea;
